import { Button, Flex } from '@zillow/constellation';
import React from 'react';
import { useCustomViewsContext } from '../../context/CustomViewsContext';

export const CreateFooter: React.FC = () => {
  const {
    customViewsState: { formikData },
    setCustomViewsState,
  } = useCustomViewsContext();
  const disabled = !(formikData?.dirty && formikData?.isValid);
  return (
    <Flex display={'flex'} flexDirection={'row-reverse'} gap={'xs'} alignItems={'center'}>
      <Button buttonType={'primary'} type={'submit'} form={'new-custom-view-form'} disabled={disabled}>
        Create new view
      </Button>
      <Button
        buttonType={'secondary'}
        onClick={() =>
          setCustomViewsState((prev) => ({ ...prev, isCreate: false, formikData: null, updatingView: null }))
        }
        type={'button'}
      >
        Cancel
      </Button>
    </Flex>
  );
};
